import React from 'react';

const cs1AssistantConversation = (
  <div className="space-y-4">
    <div className="flex">
      <div className="bg-blue-100 text-blue-900 rounded-lg px-4 py-2 max-w-3xl shadow mr-auto">
        <span className="font-bold">Assistant Agent:</span>
        <div>
          Imagine a multilingual virtual assistant. How does it affect your daily interactions?
        </div>
      </div>
    </div>
    <div className="flex justify-end">
      <div className="bg-green-100 text-green-900 rounded-lg px-4 py-2 max-w-3xl shadow ml-auto">
        <span className="font-bold">Subject:</span>
        <div>
          It makes interactions more inclusive and seamless, especially across language barriers, though occasional misinterpretations can be confusing.
        </div>
      </div>
    </div>
    <div className="flex">
      <div className="bg-blue-100 text-blue-900 rounded-lg px-4 py-2 max-w-3xl shadow mr-auto">
        <span className="font-bold">Assistant Agent:</span>
        <div>
          What about mood adaptation? If the assistant could sense and adapt to your mood, how would it affect your satisfaction?
        </div>
      </div>
    </div>
    <div className="flex justify-end">
      <div className="bg-green-100 text-green-900 rounded-lg px-4 py-2 max-w-3xl shadow ml-auto">
        <span className="font-bold">Subject:</span>
        <div>
          I'd find it supportive and calming, although sometimes overly personalized responses could be unsettling.
        </div>
      </div>
    </div>
    <div className="flex">
      <div className="bg-blue-100 text-blue-900 rounded-lg px-4 py-2 max-w-3xl shadow mr-auto">
        <span className="font-bold">Assistant Agent:</span>
        <div>
          What do you think about having multiple personas for your assistant?
        </div>
      </div>
    </div>
    <div className="flex justify-end">
      <div className="bg-green-100 text-green-900 rounded-lg px-4 py-2 max-w-3xl shadow ml-auto">
        <span className="font-bold">Subject:</span>
        <div>
          It's intriguing and adds variety, though managing multiple personalities might get complicated occasionally.
        </div>
      </div>
    </div>
  </div>
);

export default cs1AssistantConversation;
